/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { ReactNode, useEffect } from "react";

import { reportError } from "@rewards-web/shared/modules/error";

import { Alert, AlertProps } from "../../components/alert";

interface ErrorPageProps {
  message?: ReactNode;
  /**
   * If provided, will report error once.
   */
  errorToReport?: Error;
  /**
   * @default "error"
   */
  severity?: AlertProps["severity"];
}

export function ErrorPage({
  message = "An unexpected error occurred. Refresh the page to try again.",
  errorToReport,
  severity = "error",
}: ErrorPageProps): JSX.Element {
  /**
   * Only report the error once using an effect
   */
  useEffect(() => {
    if (errorToReport) {
      reportError(errorToReport);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      css={css`
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      `}
    >
      <Alert message={message} severity={severity} />
    </div>
  );
}
